import api from '@/store/helpers/api';

export default {
  state: {
    users: [],
    loggedUser: {},
    resetToken: '',
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_LOGGED_USER(state, loggedUser) {
      state.loggedUser = loggedUser;
    },
    SET_RESET_TOKEN(state, token) {
      state.resetToken = token;
    },
  },
  getters: {
    isGlobalUser: (state) => Boolean(state.loggedUser.global),
    isAdminUser: (state) => state.loggedUser.role === 'admin',
    isViewerUser: (state) => state.loggedUser.role === 'viewer',
  },
  actions: {
    loadUsers({ commit }, { global = false } = {}) {
      commit('SET_LOADING_STATE', true);
      const path = global ? 'users?global=true' : 'users';
      const mutation = global ? 'SET_DASHBOARD_GLOBAL_USERS' : 'SET_USERS';

      return new Promise((resolve, reject) => {
        return api
          .get(path)
          .then((response) => {
            const users = response.data;
            commit(mutation, users);
            resolve(users);
          })
          .catch((err) => {
            console.warn(
              'Falha ao carregar usuários:',
              err.response?.data?.message,
            );
            reject(err);
          })
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    createUser({ commit }, user) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .post('users', user)
          .then(resolve)
          .catch((err) => {
            console.warn(
              'Falha ao criar usuário:',
              err.response?.data?.message,
            );
            reject(err);
          })
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    removeUser({ commit }, userId) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .delete(`users/${userId}`)
          .then(resolve)
          .catch((err) => {
            console.warn('Falha ao remover:', err.response?.data?.message);
            reject(err);
          })
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    updateUser({ commit }, { id, email, ...user }) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .patch(`users/${id}`, user)
          .then(resolve)
          .catch((err) => {
            console.warn('Falha ao atualizar:', err.response?.data?.message);
            reject(err);
          })
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    signIn({ commit }, payload) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .post('login', payload)
          .then((response) => {
            const { accessToken, global } = response.data;

            localStorage.setItem('editor-token', accessToken);
            api.defaults.headers.common.Authorization = accessToken;
            resolve(global);
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    requestPassword({ commit }, { email }) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .post('forgot-password', { email })
          .then(() => {
            resolve();
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    resetPassword({ commit }, { token, password }) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .post(`reset-password?token=${token}`, { password })
          .then((response) => {
            const { accessToken } = response.data;

            // usuários globais não recebem token
            if (accessToken) {
              localStorage.setItem('editor-token', accessToken);
              api.defaults.headers.common.Authorization = accessToken;
            }

            resolve(accessToken);
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    verifyCode({ commit }, payload) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .post('validate-reset-code', payload)
          .then((response) => {
            const { resetToken } = response.data;

            resolve(resetToken);
          })
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    unblockUser({ commit }, id) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        return api
          .patch(`users/${id}`, { unblock: true })
          .then(resolve)
          .catch((err) => {
            console.warn('Falha ao desbloquear:', err.response?.data?.message);
            reject(err);
          })
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
  },
};
